<template>
  <div class="news_column" id="whats-new">
    <div class="title">What's New</div>
    <ul class="new_list">
      <li v-for="(item, index) in newList" :key="index">
        <div class="order">
          <div class="num">{{ item.num }}</div>
          <div class="numDate">{{ item.numDate }}</div>
        </div>
        <div class="info">{{ item.info }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "WhatsNew", // 符合ESLint多单词组件名规范，若需修改可改为"WhatsNewSection"
  data() {
    return {
      newList: [
        {
          num: "29",
          numDate: "2025-09",
          info: "We have publicly released our technical report! 🔥",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
// 定义核心断点（仅保留平板和移动端）
$tablet: 1024px; // 平板及以下（≤1024px）
$mobile: 768px; // 移动端及以下（≤768px）

.news_column {
  // background: url("../../assets/images/mobile/column.png") no-repeat;
  // background-size: 100% 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-top: 40px;
  .title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
    font-style: normal;
  }

  // 列表容器
  .new_list {
    background: url("../../assets/images/mobile/column.png") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    padding: 0;
    margin: 0;
    list-style: none; // 清除默认列表样式
    li {
      display: flex;
      align-items: center;
      // 日期数字容器
      .order {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        flex-shrink: 0; // 固定宽度，不被挤压

        .num {
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 30px;
          color: #ffffff;
          text-align: left;
          font-style: normal;
        }

        .numDate {
          margin-top: 4px;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #ffffff;
          text-align: left;
          font-style: normal;
        }
      }

      // 内容文本
      .info {
        margin-left: 25px; // 与日期区保持间距
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #efefef;
        text-align: left;
        font-style: normal;
      }
    }
  }
}

// 平板适配（≤1024px）
@media (max-width: $tablet) {
  .news_column {
    padding: 0px 15px; // 减少内边距，适配平板屏幕
    .title {
      font-size: 36px; // 缩小标题字体，避免换行
      margin-bottom: 25px; // 减少标题下间距
    }
    .new_list {
      width: 80%;
      li {
        padding: 16px 0; // 减少列表项内边距

        .order {
          margin: 10px 20px; // 日期区与内容区间距
          align-items: center; // 日期居中，符合移动端阅读习惯
          .num {
            font-size: 28px; // 缩小日期数字
          }

          .info {
            margin-left: 20px;
            font-size: 16px; // 微调文本大小
            width: 100%;
          }
        }
      }
    }
  }
}

// 移动端适配（≤768px）
@media (max-width: $mobile) {
  .news_column {
    padding: 0px 15px; // 进一步减少内边距
    .title {
      font-size: 26px; // 适配移动端的标题大小
      margin-bottom: 20px; // 减少标题下间距
    }
    .new_list {
      li {
        padding: 15px 0;

        .order {
          margin: 10px; // 日期区与内容区间距
          align-items: center; // 日期居中，符合移动端阅读习惯

          .num {
            font-size: 24px; // 适配移动端的数字大小
          }

          .numDate {
            font-size: 12px;
          }
        }

        .info {
          margin-left: 0; // 取消左间距
          width: 100%; // 内容占满屏幕
          font-size: 12px; // 适配移动端的文本大小
          text-align: center; // 文本居中，提升可读性
        }
      }
    }
  }
}
</style>
